import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getProductStockList, updateProductStcokRack, exportProductStockList } from '../../../services/ProductService';
import { searchRack } from '../../../services/RackService';
import Pagination from '../../constant/Pagination';
import { Modal, Form } from 'react-bootstrap';
import Select from 'react-select'
import { toast } from 'react-toastify';
import ExportModal from '../../constant/ExportModal';
import DebounceSearchInput from '../../constant/DebounceSearchInput';

const ProductStocks = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [data, setData] = useState([])
    const [product, setProduct] = useState(null)
    const [total, setTotal] = useState(0)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [formInput, setFormInput] = useState({ id: "", rack: null })
    const [optionRack, SetOptionRack] = useState([])
    const [isRackLoading, setIsRackLoading] = useState(false)
    const recordsPage = 10;

    useEffect(() => {
        getProductStockList(id, currentPage, recordsPage, '').then((resp) => {
            const { total, product, data } = resp.data
            setData(data)
            setTotal(total)
            setProduct(product)
        }).catch((error) => {
            console.log(error.response.data.message)
        })

    }, [id])

    const handlePagination = (page) => {
        const new_page = page.selected + 1
        getProductStockList(id, new_page, recordsPage, '').then((resp) => {
            const { total, product, data } = resp.data
            setData(data)
            setTotal(total)
            setProduct(product)
            setCurrentPage(new_page)
        }).catch((error) => {
            alert(error.response.data.message)
        })
    }

    const handleSearchChange = (value) => {
        setCurrentPage(1)
        getProductStockList(id, 1, recordsPage, value).then((resp) => {
            const { total, product, data } = resp.data
            setData(data)
            setTotal(total)
            setProduct(product)
        }).catch((error) => {
            console.log(error.response.data.message)
        })
        setSearchQuery(value)
    }

    async function fetchRackOptions() {
        try {
            setIsRackLoading(true)
            const resp = await searchRack()
            SetOptionRack(resp.data.data)
        }
        catch (error) {
            console.log("ERROR => ", error)
        } finally {
            setIsRackLoading(false)
        }
    };

    const toggleModal = (obj = null) => {
        if (isModalOpen) {

        } else {
            if (obj) {
                setFormInput({ id: obj.id, rack: { label: obj.rack.rack_no, value: obj.rack.id } })
            }
            fetchRackOptions()
        }
        setIsModalOpen(!isModalOpen)
    }

    const handleRackChange = (data) => {
        try {
            setFormInput({ ...formInput, rack: { value: data.value, label: data.label } })
        } catch (error) {
            console.log(error.response.data.message)
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const payload = {
            stock_id: formInput.id,
            rack_id: formInput.rack?.value || ""
        }
        updateProductStcokRack(id, payload).then((resp) => {
            const resp_data = resp.data
            setData(data.map(st => st.id === resp_data.data.id ? { ...resp_data.data } : st))
            toast.success(resp.data.message)
            toggleModal()
        }).catch((error) => {
            console.log("error", error)
            if (error?.message) {
                toast.error(error.response.data.message)
            }
        });
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <div className="d-flex align-items-center">
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary btn-sm rounded-circle"
                                                style={{ padding: "5px 9px" }}
                                                onClick={() => navigate(`/material/${id}`)}
                                            ><i className="fa-solid fa-arrow-left"></i></button>
                                            <h4 className="mb-0 ms-2">Stocks List of {product?.name}</h4>
                                        </div>
                                        <div className='d-flex align-items-center gap-3'>
                                            <div className='form-group'>
                                                <DebounceSearchInput handleSearchChange={handleSearchChange} />
                                            </div>

                                            <div>
                                                <ExportModal
                                                    exportApi={exportProductStockList}
                                                    idParam={id}
                                                    params={{ query: searchQuery }}
                                                    title={`Export ${product?.name} Stocks`}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tbl1" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Barcode</th>
                                                    <th>Rack</th>
                                                    <th>Quantity</th>
                                                    <th>Last Stockin Date</th>
                                                    <th>Edit Rack</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data?.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.barcode}</td>
                                                        <td>{item.rack.rack_no}</td>
                                                        <td>{item.quantity} {item.expired_date &&
                                                            <span className={`ms-2 fw-light ${new Date() > new Date(item.expired_date) ? 'text-danger' : ''}`}>
                                                                <i className="fa-regular fa-clock"></i> {item.expired_date}</span>
                                                        }
                                                        </td>
                                                        <td>{item.created_at}</td>
                                                        <td>
                                                            <button type='button' className="btn btn-outline-primary btn-sm" onClick={() => toggleModal(item)}>Edit Rack</button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                        <Pagination
                                            currentPage={currentPage}
                                            recordsPage={recordsPage}
                                            dataLength={total}
                                            handlePagination={handlePagination}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal fade" id="exampleModal1" show={isModalOpen} onHide={toggleModal}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel1">Edit Stock Rack</h1>
                        <button type="button" className="btn-close" onClick={toggleModal}></button>
                    </div>
                    <div className="modal-body">
                        <Form onSubmit={(e) => { handleSubmit(e) }} method='POST'>
                            <div className="row">
                                <div className="col-xl-12">
                                    <label>Rack</label>
                                    <Select
                                        value={formInput.rack}
                                        onChange={(data) => handleRackChange(data)}
                                        placeholder={"Select Rack"}
                                        isClearable={false}
                                        isLoading={isRackLoading}
                                        options={optionRack}
                                        id={"rack"}
                                        className='react-select'
                                        classNamePrefix='select'
                                    />

                                </div>
                            </div>
                            <button type="submit" className="btn btn-primary mt-3 float-end">Update Stock Rack</button>
                        </Form>
                    </div>
                </div>
            </Modal>
        </>
    );
};
export default ProductStocks;